import { PanelBottomOpen, PanelTopOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { ContentItem } from "@/types/content";

interface ContentToggleButtonProps {
  content: ContentItem;
  isExpanded: boolean;
  onToggle: () => void;
}

function getToggleLabel(type: ContentItem["type"], isExpanded: boolean): string {
  const contentTypeLabels: Record<string, { show: string; hide: string }> = {
    pdf: { show: "Show PDF", hide: "Hide PDF" },
    doc: { show: "Show Document", hide: "Hide Document" },
    youtube: { show: "Show Video", hide: "Hide Video" },
    video: { show: "Show Video", hide: "Hide Video" },
    audio: { show: "Show Audio", hide: "Hide Audio" },
    recording: { show: "Show Recording", hide: "Hide Recording" },
    web: { show: "Show Website", hide: "Hide Website" },
    text: { show: "Show Content", hide: "Hide Content" },
  };

  const labels = contentTypeLabels[type] || { show: "Show Content", hide: "Hide Content" };
  return isExpanded ? labels.hide : labels.show;
}

export function ContentToggleButton({ content, isExpanded, onToggle }: ContentToggleButtonProps) {
  const label = getToggleLabel(content.type, isExpanded);
  const Icon = isExpanded ? PanelTopOpen : PanelBottomOpen;

  return (
    <div className="mb-2 flex justify-center px-2">
      <Button
        variant="outline"
        onClick={onToggle}
        aria-expanded={isExpanded}
        className="h-9 w-full flex items-center justify-center gap-2 rounded-lg px-3 shadow-sm whitespace-nowrap text-sm font-medium"
      >
        <Icon className="h-4 w-4" aria-hidden="true" />
        <span>{label}</span>
      </Button>
    </div>
  );
}
